const API_URL = "https://nordhousemap.online/back"; // Продакшн сервер
//const API_URL = "http://localhost:8000"; // Локальный сервер (раскомментируй при тестах)
//const API_URL = "http://10.8.1.1:8000";
//const API_URL = "http://192.168.0.106:8000";
export default API_URL;
